module.exports = __webpack_public_path__ + "static/media/front-view.6b9492a2.jpg";